import { Component } from '@angular/core';
import { GetDemoFormComponent } from "src/app/components/layout/get-demo-form/get-demo-form.component";

@Component({
  selector: 'app-privacy-policy',
  standalone: true,
  imports: [GetDemoFormComponent],
  templateUrl: './privacy-policy.component.html',
  styleUrl: './privacy-policy.component.scss'
})
export class PrivacyPolicyComponent {

}
